var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    staticClass: "modify-modal modify-modal__discard-edits",
    attrs: { variant: "default", "no-footer": "" },
    on: { input: _vm.handleOpenModal, close: _vm.handleCloseModal },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function (ref) {
            var activate = ref.activate
            return [_vm._t("default", null, null, { activate: activate })]
          },
        },
        {
          key: "body",
          fn: function () {
            return [
              _c("p", { staticClass: "text" }, [_vm._v(_vm._s(_vm.text))]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button--primary black size-md",
                  on: {
                    click: _vm.dismiss,
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.dismiss($event)
                    },
                  },
                },
                [_vm._v("\n      " + _vm._s(_vm.buttonLabel) + "\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }